import React from "react";
import { cn } from "@/lib/utils";
import { membershipTypeForDisplay, type MembershipType } from "@/types/MembershipType";
import type { Booking } from "@/types/Booking";

type BookingTypePillProps = {
  booking: Booking;
  className?: string;
};

/**
 * Pill-specific label for the booking type. We abbreviate "Flexible" to "Flex" inside the pill
 * (per UX feedback 2026-05-19) — other surfaces continue to use the full "Flexible" via
 * `membershipTypeForDisplay`. Everything else uses the long label. Exported so the calendar
 * bubble (Bubble.tsx) can share the same mapping.
 */
export const pillLabelFor = (type: MembershipType | undefined): string => {
  if (!type) return "Unknown";
  if (type === ("adhoc" as MembershipType)) return "Flex";
  return membershipTypeForDisplay(type).long || "Unknown";
};

const BookingTypePill: React.FC<BookingTypePillProps> = ({ booking, className }: BookingTypePillProps) => {
  return (
    <span
      className={cn(
        "inline-block px-2 py-0.5 rounded-full bg-gray-200 text-base font-semibold text-gray-700",
        className,
      )}
      data-testid="booking-type-pill"
    >
      {pillLabelFor(booking.type as MembershipType | undefined)}
    </span>
  );
};

export default BookingTypePill;
